"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports["default"] = exports.HONEYGUIDE_DEFAULT_IMAGE = void 0;

var _config = _interopRequireDefault(require("./config"));

var icons = _interopRequireWildcard(require("./icons"));

exports.icons = icons;
var ASSETS_URL = _config["default"].ASSETS_URL;
var HONEYGUIDE_DEFAULT_IMAGE = "".concat(ASSETS_URL, "/honeyguide-to-the-mountains.jpg");
exports.HONEYGUIDE_DEFAULT_IMAGE = HONEYGUIDE_DEFAULT_IMAGE;
var _default = _config["default"];
exports["default"] = _default;